import { useTranslation } from "react-i18next";
import { ModalApp } from "../ModalApp";
import styleModal from "./ModalKYC.module.scss";
import { ROUTES } from "../../../../hooks";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as WARN } from "../../../../assets/images/destroyed-asset.svg";
import ButtonContainer from "../../ButtonContainer/ButtonContainer";
import classNames from "classnames";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from "../../../../services/hooks.service";
import { useCallback, useEffect, useState } from "react";
import { equalsIgnoreCase, isKeyExpired } from "../../../../_utils";
import { saveExpiredTKInfo } from "../../../../redux/_actions/persist.action";

export const TradingKeyModal = () => {
  const keyFromStorage = useAppSelector((state) => state.user.userLockalKey);
  const showExpiredTKInfo = useAppSelector((state) => state.persist.showExpiredTKInfo);
  const [keyTime, setKeyTime] = useState(false);
  const isLogged = useIsLoggedSelector();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onHandle = () => {
    navigate(ROUTES.account, { state: { manageKey: true } });
    onHide();
  }

  const onHide = useCallback(() => {
    dispatch(saveExpiredTKInfo(keyFromStorage.address));
    setKeyTime(false);
  }, [keyFromStorage]);
  
  useEffect(() => {
    if (keyFromStorage && isLogged) {
      setKeyTime(isKeyExpired(keyFromStorage.expiredAt));
    } else {
      setKeyTime(false);
    }
  }, [isLogged, keyFromStorage]);

  return (
    <ModalApp show={keyTime && !equalsIgnoreCase(showExpiredTKInfo, keyFromStorage?.address)}>
      <p className={styleModal.header_tk_modal}><WARN />{ t("obd_modals.your_key_expired") }</p>
      <p className={styleModal.big_LH}>{ t("obd_modals.your_key_expired_expl") }</p>
      <p className={classNames(styleModal.big_LH, "text_gray")}>{ t("obd_modals.keys_are_configurable") }</p>
      <ButtonContainer 
        saveButton={onHandle} 
        cancelButton={onHide} 
        cancelTxt={ t("comman_word.dismiss_txt") }
        saveTxt={ t("obd_modals.create_new_key") }
      />
    </ModalApp>
  );
}
